// IIFE guards top-level consts from colliding with quiz-modal.js / quiz-results-products.js.
(() => {
const ANSWERS_STORAGE_KEY = 'themex-quiz-answers';

document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('.quiz-results-hero');
  if (!section) return;

  let answers = null;
  try {
    const raw = localStorage.getItem(ANSWERS_STORAGE_KEY);
    if (raw) answers = JSON.parse(raw);
  } catch {
    answers = null;
  }

  const tagsContainer = section.querySelector('[data-quiz-tags]');
  const tagTemplate = section.querySelector('[data-profile-tag-template]');
  if (!tagsContainer || !tagTemplate) return;

  // No answers → leave the merchant-authored placeholder tag in place. The
  // products section renders the "Take the quiz" empty state alongside.
  if (!answers || typeof answers !== 'object') return;

  tagsContainer.replaceChildren();

  // questionIndex is each question's fixed authored position (set in
  // quiz-modal.js), so tags display in real quiz order even if the shopper
  // went back and re-answered a question out of sequence. Answers saved by
  // an older version of quiz-modal.js won't have it — Object.keys' insertion
  // order (still the answer order in the common, no-going-back case) is the
  // fallback for those, sorted after any answer that does have an index.
  const orderedKeys = Object.keys(answers).sort((a, b) => {
    const indexA = answers[a]?.questionIndex;
    const indexB = answers[b]?.questionIndex;
    if (typeof indexA === 'number' && typeof indexB === 'number') return indexA - indexB;
    if (typeof indexA === 'number') return -1;
    if (typeof indexB === 'number') return 1;
    return 0;
  });

  for (const key of orderedKeys) {
    const answer = answers[key];
    const label = answer?.optionTitle;
    if (!label || typeof label !== 'string') continue;
    const node = tagTemplate.content.cloneNode(true);
    const slot = node.querySelector('[data-profile-tag-slot]');
    if (slot) slot.textContent = label;
    tagsContainer.appendChild(node);
  }
});
})();
